import { Injectable, Injector } from '@angular/core';

import { DateService } from './date.service';
import { UtilsService } from './utils.service';
import type { TReportOptions, TTimestamp } from '@shared/models';
import { Constants } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

@Injectable({
    'providedIn': 'root'
})
export class BaseReportService {
    protected utilsService: UtilsService;
    protected dateService: DateService;
    protected options!: TReportOptions;
    
    // private utilsService: UtilsService)
    constructor(injector: Injector) {
        this.utilsService = injector.get(UtilsService);
        this.dateService = injector.get(DateService);
    }

    protected initialize(reportOptions: TReportOptions) {
        this.options = reportOptions;
    }

    public buildRowInfo(columnValues: string[], type: string, myClass: string = '') {
        const values: { value: string }[] = [];
        
        columnValues.forEach((value) => {
            const obj = { 'value': value };
            values.push(obj);
        });
        const rowInfo = { 'cells': values, 'type': type, 'myClass': myClass };
        return rowInfo;
    }

    public getBlankLine() {
        const blankLine = this.buildRowInfo([' '], 'summary');
        return blankLine;
    }

    public truncateWithEllipsis(message: string, maxLen: number = 100) {
        if (!message) {
            return null;
        }
        let newMessage = message.substr(0, maxLen - 3);
        newMessage += '...';
        return newMessage;
    }

    /*
    private sort<K extends keyof TTicket>(tickets: TTicket[], sortColumn: K): TTicket[] {
        tickets.sort((a: TTicket, b: TTicket) => {
            const aValue = a[sortColumn];
            const bValue = b[sortColumn];
            
            // Handle undefined/null values - put them at the end
            if (aValue === undefined || aValue === null) return 1;
            if (bValue === undefined || bValue === null) return -1;

            if (aValue < bValue) {
                return -1;
            } else if (aValue > bValue) {
                return 1;
            } else {
                return 0;
            }
        });
        return tickets;
    }    
    */

    /*
    public sortData(rows: any[], option: TReportOptions) {
        const count = option.selectedReport.sortColumns.length;
        const sortColumn1 = (count > 0 ? option.selectedReport.sortColumns[0] : null);
        const sortColumn2 = (count > 1 ? option.selectedReport.sortColumns[1] : null);

        switch (count) {
            case 1:
                rows.sort((a, b) => {
                    const col1 = a.cells[sortColumn1];
                    const col2 = b.cells[sortColumn1];

                    // Handle undefined/null values - put them at the end
                    if (col1 === undefined || col1 === null) return 1;
                    if (col2 === undefined || col2 === null) return -1;

                    if (col1 < col2) {
                        return -1;
                    } else if (col1 > col2) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
                break;

            case 2:
                // console.error('2 column sort not implemented yet.');
                break;
        }
        return rows;
    }
*/
    public sortData(rows: any[], option: TReportOptions) {
        // Guard clause - return early if no sort columns defined
        if (!option.selectedReport?.sortColumns || option.selectedReport.sortColumns.length === 0) {
            return rows;
        }

        const count = option.selectedReport.sortColumns.length;
        const sortColumn1 = count > 0 ? option.selectedReport.sortColumns[0] : null;
        // const sortColumn2 = count > 1 ? option.selectedReport.sortColumns[1] : null;

        switch (count) {
            case 1:
                rows.sort((a, b) => {
                    const col1 = a.cells[sortColumn1];
                    const col2 = b.cells[sortColumn1];

                    // Handle undefined/null values - put them at the end
                    if (col1 === undefined || col1 === null) return 1;
                    if (col2 === undefined || col2 === null) return -1;

                    if (col1 < col2) {
                        return -1;
                    } else if (col1 > col2) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
                break;

            case 2:
                // console.error('2 column sort not implemented yet.');
                break;
        }
        return rows;
    }

    public formatDate(timestamp: TTimestamp): string {
        return this.dateService.formatTimestamp(timestamp, DateTimeFormats.LongDate);
    }

    public formatTime(timestamp: TTimestamp): string {
        return this.dateService.formatTimestamp(timestamp, DateTimeFormats.ShortTime);
    }

    public formatDateTime(timestamp: TTimestamp): string {
        return this.dateService.formatTimestamp(timestamp, DateTimeFormats.Full);
    }

    protected formatDuration(start: TTimestamp, end: TTimestamp): string {
        return this.dateService.formatDuration(start, end);
    }

    // public formatTimeAndDuration(start: TTimestamp, end: TTimestamp): string {
    // return this.dateService.formatTimeAndDuration(start, end);
    // const timeStart = this.formatTime(start);
    // const timeEnd = this.formatTime(end);
    // const duration = this.formatDuration(start, end);
    // const str = timeStart + ' (+' + duration + ')';
    // return str;
    // }
}
